<img
    src="images/not-found.svg"
    alt="Not Found" />
<h3>{{ 'notFound.title' | translate }}</h3>

<ra-button
    [label]="'notFound.backToHome' | translate"
    [type]="'primary'"
    (click)="navigateToHome()"
/>
